import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

export async function sendGeneralInstructionEmail(listingId: string) {
  try {
    const response = await fetch(
      baseUrl + "/api/SlotBookingEmail/SendGeneralInstructionEmail",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
        body: JSON.stringify({
          listingId: listingId,
        }),
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}
